const mutations = {
  // root:
  SET_LOGGED_OUT_STATE: 'SET_LOGGED_OUT_STATE',
  KEEP_SESSION: 'KEEP_SESSION',

  // wallet:
  SET_WALLET_ID: 'SET_WALLET_ID',

  // user:
  SET_USER_EMAIL: 'SET_USER_EMAIL',
  SET_USER_CREATED_AT: 'SET_USER_CREATED_AT',
  SET_USER_TAURUS: 'SET_USER_TAURUS',
  SET_USER_XPAY: 'SET_USER_XPAY',
  SET_USER_UPLATA_INSHA: 'SET_USER_UPLATA_INSHA',
  DELETE_USER_TAURUS: 'DELETE_USER_TAURUS',
  DELETE_USER_UPLATA_INSHA: 'DELETE_USER_UPLATA_INSHA',
  SET_LOCALE: 'SET_LOCALE',
  // users:
  SET_LIST_CORPORATE_USERS: 'SET_LIST_CORPORATE_USERS',

  // Server config
  SET_SERVER_CONFIG: 'SET_SERVER_CONFIG',

  // account:
  SET_MASTER_ACCOUNT_ID: 'SET_MASTER_ACCOUNT_ID',
  SET_OPERATIONAL_ACCOUNT_ID: 'SET_OPERATIONAL_ACCOUNT_ID',
  SET_ACCOUNT_KEYS: 'SET_ACCOUNT_KEYS',
  SET_ACCOUNT_BALANCES: 'SET_ACCOUNT_BALANCES',
  SET_ACCOUNT_SIGNER: 'SET_ACCOUNT_SIGNER',
  SET_ACCOUNT_INVESTMENT_BALANCES: 'SET_ACCOUNT_INVESTMENT_BALANCES',
  SET_ACCOUNT_DETAILS: 'SET_ACCOUNT_DETAILS',
  SET_ACCOUNT_LIMITS: 'SET_ACCOUNT_LIMITS',

  // account.kyc:
  SET_ACCOUNT_KYC_REQUESTS: 'SET_ACCOUNT_KYC_REQUESTS',
  SET_ACCOUNT_KYC_DATA: 'SET_ACCOUNT_KYC_DATA',
  SET_ACCOUNT_KYC_TYPE: 'SET_ACCOUNT_KYC_TYPE',
  SET_ACCOUNT_KYC_DOCUMENTS: 'SET_ACCOUNT_KYC_DOCUMENTS',

  // transactions:
  SET_TX_LIST_INITIALIZED: 'SET_TX_LIST_INITIALIZED',
  UPDATE_TX_LIST: 'UPDATE_TX_LIST',
  UPDATE_TX_LIST_ITEM: 'UPDATE_TX_LIST_ITEM',
  UPDATE_TWO_FACTOR_STATE: 'UPDATE_TWO_FACTOR_STATE',

  // assets:
  SET_CURRENT_ASSET: 'SET_CURRENT_ASSET',
  COMMIT_CURRENT_ASSET: 'COMMIT_CURRENT_ASSET',

  // pairs:
  SET_ASSET_PAIRS: 'SET_ASSET_PAIRS',
  SET_ASSET_PAIRS_SHORT: 'SET_ASSET_PAIRS_SHORT',

  // giftmall
  SET_GIFTMALL_CONFIG: 'SET_GIFTMALL_CONFIG',
  SET_GIFTMALL_PRE_ORDER: 'SET_GIFTMALL_PRE_ORDER',

  // trades:
  SET_SELL_OFFERS: 'SET_SELL_OFFERS',
  SET_BUY_OFFERS: 'SET_BUY_OFFERS',

  // tokens:
  SET_ALL_TOKENS: 'SET_ALL_TOKENS',

  // sales:
  SET_SALES: 'SET_SALES',
  UPDATE_SALE_REQUEST_LIST: 'UPDATE_SALE_REQUEST_LIST',
  UPDATE_SALE_REQUEST_LIST_ITEM: 'UPDATE_SALE_REQUEST_LIST_ITEM',
  SET_SALE_REQUEST_LIST_INITIALIZED: 'SET_SALE_REQUEST_LIST_INITIALIZED',

  // notifications
  UPDATE_MESSAGES: 'UPDATE_MESSAGES',
  SSE_NEW_MESSAGES: 'SSE_NEW_MESSAGES',

  // webshop
  UPDATE_DETAILS: 'UPDATE_DETAILS',

  // Owners
  SET_LIST_OWNERS: 'SET_LIST_OWNERS',

  // 2FA:
  SET_FACTOR_DATA: 'SET_FACTOR_DATA'
}

const actions = {
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT',
  setApproverData: 'setApproverData',
  setMerchantId: 'setMerchantId',
  // wallet:
  PROCESS_USER_WALLET: 'PROCESS_USER_WALLET',
  STORE_USER_DATA_FROM_WALLET: 'STORE_USER_DATA_FROM_WALLET',

  // user:
  GET_USER_DETAILS: 'GET_USER_DETAILS',
  GET_USER_FAVORITES: 'GET_USER_FAVORITES',
  GET_USER_TAURUS: 'GET_USER_TAURUS',
  GET_USER_XPAY: 'GET_USER_XPAY',
  GET_USER_UPLATA_INSHA: 'GET_USER_UPLATA_INSHA',
  GET_USER_LOCALE: 'GET_USER_LOCALE',
  SET_USER_LOCALE: 'SET_USER_LOCALE',

  // users:
  GET_LIST_CORPORATE_USERS: 'GET_LIST_CORPORATE_USERS',

  // Server config
  GET_SERVER_CONFIG: 'GET_SERVER_CONFIG',

  // account:
  GET_MASTER_ACCOUNT_ID: 'GET_MASTER_ACCOUNT_ID',
  GET_OPERATIONAL_ACCOUNT_ID: 'GET_OPERATIONAL_ACCOUNT_ID',
  GET_ACCOUNT_DETAILS: 'GET_ACCOUNT_DETAILS',
  GET_ACCOUNT_BALANCES: 'GET_ACCOUNT_BALANCES',
  GET_ACCOUNT_SIGNER: 'GET_ACCOUNT_SIGNER',
  GET_ACCOUNT_INVESTMENT_BALANCES: 'GET_ACCOUNT_INVESTMENT_BALANCES',
  GET_ACCOUNT_LIMITS: 'GET_ACCOUNT_LIMITS',
  // account.kyc:
  GET_ACCOUNT_KYC_DATA: 'GET_ACCOUNT_KYC_DATA',
  GET_ACCOUNT_KYC_REQUESTS: 'GET_ACCOUNT_KYC_REQUESTS',
  UPDATE_ACCOUNT_KYC_DATA: 'UPDATE_ACCOUNT_KYC_DATA',
  UPDATE_ACCOUNT_KYC_DOCUMENTS: 'UPDATE_ACCOUNT_KYC_DOCUMENTS',

  // transactions:
  INIT_TX_LIST: 'INIT_TX_LIST',
  GET_TX_LIST: 'GET_TX_LIST',
  GET_TX_LIST_SECOND: 'GET_TX_LIST_SECOND',
  NEXT_TX_LIST: 'NEXT_TX_LIST',
  UPDATE_TX_COUNTERPARTIES: 'UPDATE_TX_COUNTERPARTIES',
  SET_TWO_FACTOR_STATE: 'SET_TWO_FACTOR_STATE',

  // pairs:
  GET_ASSET_PAIRS: 'GET_ASSET_PAIRS',
  GET_ASSET_PAIRS_SHORT: 'GET_ASSET_PAIRS_SHORT',

  // giftmall:
  GET_GIFTMALL_CONFIG: 'GET_GIFTMALL_CONFIG',
  GET_GIFTMALL_PRE_ORDER: 'GET_GIFTMALL_PRE_ORDER',

  // trades:
  GET_TRADES: 'GET_TRADES',
  GET_SM_OFFERS: 'GET_SM_OFFERS',
  GET_BUY_OFFERS: 'GET_BUY_OFFERS',
  GET_SELL_OFFERS: 'GET_SELL_OFFERS',
  GET_USER_OFFERS: 'GET_USER_OFFERS',

  // tokens:
  GET_ALL_TOKENS: 'GET_ALL_TOKENS',

  // sales:
  GET_SALES: 'GET_SALES',
  GET_SALES_BY_NAME: 'GET_SALES_BY_NAME',

  // requests:
  GET_USER_TOKENS_CREATION_REQUESTS: 'GET_USER_TOKENS_CREATION_REQUESTS',
  NEXT_USER_TOKENS_CREATION_REQUESTS: 'NEXT_USER_TOKENS_CREATION_REQUESTS',
  GET_USER_PREISSUANCE_UPLOAD_REQUESTS: 'GET_USER_PREISSUANCE_UPLOAD_REQUESTS',
  NEXT_USER_PREISSUANCE_UPLOAD_REQUESTS: 'NEXT_USER_PREISSUANCE_UPLOAD_REQUESTS',
  GET_USER_SALE_CREATION_REQUESTS: 'GET_USER_SALE_CREATION_REQUESTS',
  NEXT_USER_SALE_CREATION_REQUESTS: 'NEXT_USER_SALE_CREATION_REQUESTS',
  INIT_SALE_REQUESTS_LIST: 'INIT_SALE_REQUESTS_LIST',
  GET_LIMITS_REQUESTS: 'GET_LIMITS_REQUESTS',
  NEXT_LIMITS_REQUESTS: 'NEXT_LIMITS_REQUESTS',
  GET_USER_CONTRACT_CREATION_REQUESTS: 'GET_USER_CONTRACT_CREATION_REQUESTS',
  NEXT_USER_CONTRACT_CREATION_REQUESTS: 'NEXT_USER_CONTRACT_CREATION_REQUESTS',
  GET_USER_INVOICES_REQUESTS: 'GET_USER_INVOICES_REQUESTS',
  NEXT_USER_INVOICES_REQUESTS: 'NEXT_USER_INVOICES_REQUESTS',

  // contracts:
  GET_SIGNED_CONTRACTS: 'GET_SIGNED_CONTRACTS',
  NEXT_SIGNED_CONTRACTS: 'NEXT_SIGNED_CONTRACTS',
  GET_ARCHIVED_CONTRACTS: 'GET_ARCHIVED_CONTRACTS',
  NEXT_ARCHIVED_CONTRACTS: 'NEXT_ARCHIVED_CONTRACTS',

  // withdrawals:
  GET_WITHDRAWALS: 'GET_WITHDRAWALS',
  NEXT_WITHDRAWALS: 'NEXT_WITHDRAWALS',

  // notifications:
  MARK_READ_MESSAGES: 'MARK_READ_MESSAGES',
  GET_UNREAD_MESSAGES: 'GET_UNREAD_MESSAGES',

  // webshop:
  LOAD_TICKET_DETAILS: 'LOAD_TICKET_DETAILS',

  // Owners:
  GET_LIST_OWNERS: 'GET_LIST_OWNERS',

  // 2FA:
  SET_FACTOR_DATA: 'SET_FACTOR_DATA'
}

const getters = {
  isLoggedIn: 'isLoggedIn',

  // user:
  userEmail: 'userEmail',
  userType: 'userType',
  userCreatedAt: 'userCreatedAt',
  userTaurus: 'userTaurus',
  userXpay: 'userXpay',
  userUplataInsha: 'userUplataInsha',
  userFavorites: 'userFavorites',
  usercorporate: 'userFavorites',
  getUserLocale: 'getUserLocale',

  // users:
  getCorporateUsers: 'getCorporateUsers',

  // wallet:
  walletId: 'walletId',

  // account:
  // TODO: need 'userAccountId' and 'keypair' for backwards compatibility only
  historyLatestLedger: 'historyLatestLedger',
  historyElderLedger: 'historyElderLedger',
  coreLatestLedger: 'coreLatestLedger',
  networkPassphrase: 'networkPassphrase',
  commissionAccountId: 'commissionAccountId',
  operationalAccountId: 'operationalAccountId',
  storageFeeAccountId: 'storageFeeAccountId',
  exchangeOperatorAccountId: 'exchangeOperatorAccountId',
  masterAccountId: 'masterAccountId',
  masterExchangeName: 'masterExchangeName',
  txExpirationPeriod: 'txExpirationPeriod',
  currentTime: 'currentTime',
  precision: 'precision',
  cryptoPrecision: 'cryptoPrecision',
  fiatPrecision: 'fiatPrecision',
  cryptoCurrencies: 'cryptoCurrencies',
  userAccountId: 'accountId',
  keypair: 'accountKeypair',
  account: 'account',
  accountId: 'accountId',
  accountType: 'accountType',
  accountTypeI: 'accountTypeI',
  accountBlocked: 'accountBlocked',
  accountBlockedReasons: 'accountBlockedReasons',
  accountLimits: 'accountLimits',
  accountSeed: 'accountSeed',
  approverData: 'approverData',
  accountSignerName: 'accountSignerName',
  accountPublicKey: 'accountPublicKey',
  accountKeypair: 'accountKeypair',
  accountCreatedAt: 'accountCreatedAt',
  accountTokens: 'accountTokens',
  accountBalances: 'accountBalances',
  accountInvestmentBalances: 'accountInvestmentBalances',
  accountOwnedTokens: 'accountOwnedTokens',
  accountRawBalances: 'accountRawBalances',
  accountDepositAddresses: 'accountDepositAddresses',
  // account.kyc:
  accountState: 'accountState',
  accountKycRejectReason: 'accountKycRejectReason',
  accountKycData: 'accountKycData',
  accountKycDocuments: 'accountKycDocuments',
  accountLatestBlobId: 'accountLatestBlobId',
  accountKycLatestRequest: 'accountKycLatestRequest',
  accountLatestKycLevel: 'accountLatestKycLevel',
  accountNotVerifiedYet: 'accountNotVerifiedYet',
  accountVerified: 'accountVerified',
  isSystemAccount: 'isSystemAccount',

  // tokens:
  tokens: 'tokens',
  walletTokens: 'walletTokens',
  statsQuoteToken: 'statsQuoteToken',
  userOwnedTokens: 'userOwnedTokens',
  userAcquiredTokens: 'userAcquiredTokens',
  userWalletTokens: 'userWalletTokens',
  userTransferableTokens: 'userTransferableTokens',
  userWithdrawableTokens: 'userWithdrawableTokens',
  userCashTokens: 'userCashTokens',
  userKycDetails: 'userKycDetails',
  userKycDocuments: 'userKycDocuments',

  // transactions:
  transactions: 'transactions',
  twoFactor: 'twoFactor',

  // assets:
  currentAsset: 'currentAsset',

  // pairs:
  assetPairs: 'assetPairs',
  assetPairsShort: 'assetPairsShort',
  tradablePairs: 'tradablePairs',

  // giftMall:
  giftMallConfig: 'giftMallConfig',
  giftMallPreOrder: 'giftMallPreOrder',

  // trades:
  trades: 'trades',
  buyOffers: 'buyOffers',
  sellOffers: 'sellOffers',
  userOffers: 'userOffers',

  // requests:
  tokenCreationRequests: 'tokenCreationRequests',
  saleCreationRequests: 'saleCreationRequests',
  preIssuanceUploadRequests: 'preIssuanceUploadRequests',
  limitsRequests: 'limitsRequests',
  isLimitsRequestsLoaded: 'isLimitsRequestsLoaded',
  contractCreationRequests: 'contractCreationRequests',
  invoicesRequests: 'invoicesRequests',

  // sales:
  sales: 'sales',
  salesOwned: 'salesOwned',
  starredSales: 'starredSales',
  saleIds: 'saleIds',

  // offers:
  saleOffers: 'saleOffers',

  // contracts:
  signedContracts: 'signedContracts',
  archivedContracts: 'archivedContracts',

  // withdrawals:
  withdrawals: 'withdrawals',

  // notifications
  getUnreadMessages: 'getUnreadMessages',

  // webshop
  getWebshopDetails: 'getWebshopDetails',

  // Owners
  ownersList: 'ownersList',

  // 2FA:
  factorData: 'factorData',

  isProductionEnv: 'isProductionEnv',
  isForcedMenuHidden: 'isForcedMenuHidden'
}

export const vuexTypes = {
  ...mutations,
  ...actions,
  ...getters
}



// WEBPACK FOOTER //
// ./src/vuex/types.js